export default __webpack_public_path__ + "85c42a7f0488bfb6607cbcc6aebc1566.png";